<template>
  <section class="page-container" :class="type">
    <div class="page-content">
      <slot />
    </div>
  </section>
</template>
<script>
export default {
  props: {
    type: {
      default: 'bg1',
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
.bg1 {
  background-image: url("../assets/img/bg-1.jpg"), url("../assets/img/bg-2.jpg");
  background-position: left top, right bottom;
  background-size: 150px;
  @include minWidth992 {
    background-size: auto;
  }
}
.bg2 {
  background-image: url("../assets/img/award-bg-1.jpg"), url("../assets/img/award-bg-2.jpg");
  background-position: right top, left bottom;
  background-size: contain;
  @include minWidth992 {
    background-size: auto;
  }
}
.page-container {
  background-repeat: no-repeat, no-repeat;
  background-color: #faf3fa;;
  display: flex;
  align-items: flex-start;
  width: 100%;
  @include minWidth992 {
    padding-right: 100px;
  }
}
.page-content {
  @include InnerContainer;
  padding-top: 40px;
  padding-bottom: 40px;
  @include minWidth992 {
    padding-top: 0px;
    padding-bottom: 0px;
    margin-top:120px;
    margin-bottom: 60px;
  }
}
</style>
